'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = isEmptyHexString;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isEmptyHexString(hex) {
  if (typeof hex !== 'string') return false;

  var prefix = hex.slice(0, 2);
  var rest = [].concat((0, _toConsumableArray3.default)(hex.slice(2)));
  return prefix === '0x' && rest.every(function (char) {
    return char === '0';
  });
}
//# sourceMappingURL=isEmptyHexString.js.map